import { useState } from 'react'
import { Button, Popover } from '@mantine/core'
import { IconFilter } from '@tabler/icons-react'
import TableFilter from './TableFilter'

function ActiveTableFilters({ availableFilters, tableState }) {
    const entries = Object.entries(tableState.filters ?? {})
    if (!entries.length) return null
    return <div className="min-w-0 truncate text-sm leading-5" aria-label="Filtres actifs">
        {entries.map(([key, value]) => {
            const filter = availableFilters.find((item) => item.key === key)
            const label = (Array.isArray(value) ? value : [value]).map((entry) =>
                filter?.options?.find((option) => String(option.value) === String(entry))?.label ?? String(entry)
            ).join(', ')
            return <span key={key} className="mr-3 last:mr-0" title={`${filter?.name ?? key} : ${label}`}>
                {filter?.name ?? key} : <span className="text-gray-500">{label}</span>
            </span>
        })}
    </div>
}

export default function TableFilters({ availableFilters = [], tableState, changeFilters }) {
    const [opened, setOpened] = useState(false)
    const count = Object.keys(tableState.filters ?? {}).length
    const changeFilter = (key, value) => {
        const next = { ...tableState.filters }
        if (value == null || value === '' || (Array.isArray(value) && !value.length)) delete next[key]
        else next[key] = value
        changeFilters(next)
    }

    return <div className="flex min-w-0 items-center gap-3">
        <Popover opened={opened} onChange={setOpened} position="bottom-start" width={560} shadow="md" radius="lg" withinPortal={false} trapFocus={false} returnFocus>
            <Popover.Target>
                <Button className="shrink-0" variant="default" rightSection={<IconFilter size={14} />} onKeyDown={(event) => { if (event.key === 'Escape') setOpened(false) }} onClick={() => setOpened((value) => !value)}>
                    Filtres{count > 0 && <span className="ml-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-100 px-1 text-xs font-medium">{count}</span>}
                </Button>
            </Popover.Target>
            <Popover.Dropdown p="md" style={{ maxWidth: 'calc(100vw - 24px)' }}>
                <div className="max-h-[min(520px,65dvh)] overflow-y-auto overscroll-contain">
                    <div className="flex flex-col gap-4">
                        {availableFilters.map((filter, index) => <TableFilter key={`${filter.key}-${index}`} filter={filter} tableState={tableState} changeFilter={changeFilter} />)}
                    </div>
                </div>
                {count > 0 && <div className="mt-4 border-t pt-3">
                    <Button variant="subtle" color="gray" size="compact-sm" onClick={() => changeFilters({})}>Réinitialiser les filtres</Button>
                </div>}
            </Popover.Dropdown>
        </Popover>
        <ActiveTableFilters availableFilters={availableFilters} tableState={tableState} />
    </div>
}
